import { FC } from 'react';
import { useTheme } from 'styled-components';

import { useModal } from '@libs/components';
import { screenSizes } from '@libs/theme';

import { useDimensions, useTranslation } from 'src/hooks';
import { ReferralUsdtBanner } from 'src/assets';
import { BonusTotal } from 'src/gql';

import { ReferralRuleDetails } from '../referral-rule-details/ReferralRuleDetails';

import {
  BlueContainer,
  ReferralRulesGlass,
  CustomReferralRules,
  CustomReferralSummary,
  CustomReferralIntroduceOffer,
} from './styles';
import { ReferralBalanceSummary } from './ReferralBalanceSummary';

type ReferralBlueBlockProps = {
  hasInvitedUsers: boolean;
  response?: BonusTotal;
};

const ReferralBlueBlock: FC<ReferralBlueBlockProps> = ({
  hasInvitedUsers,
  response,
}) => {
  const { Dialog, openModal } = useModal();

  const { colors } = useTheme();

  const { t } = useTranslation();

  const { width } = useDimensions();

  const titleType = width >= screenSizes.laptop ? 'largeTitle' : undefined;

  return (
    <>
      <Dialog
        title={t('referral_rules')}
        headerBackground={colors.text.interactive}
        shouldHideHeaderBorder
      >
        <ReferralRuleDetails />
      </Dialog>
      <BlueContainer className="container">
        {hasInvitedUsers ? (
          <ReferralBalanceSummary
            handleInfoIconClick={openModal}
            response={response}
          />
        ) : (
          <ReferralRulesGlass>
            <CustomReferralRules
              handleSeeRulesClick={openModal}
              titleType={titleType}
              blueBlockTitle={t('referral_blue_block_title')}
              seeRules={t('referral_see_rules')}
              blueBlockFirstTitle={t('referral_invite_friends_first_part')}
              blueBlockFirstDesc={t('referral_percentage')}
              blueBlockThirdDText={t('referral_invite_friends_second_part')}
              ReferralsUsdtBanner={ReferralUsdtBanner}
            />
          </ReferralRulesGlass>
        )}
      </BlueContainer>
      {hasInvitedUsers && (
        <>
          <CustomReferralIntroduceOffer />

          <CustomReferralSummary response={response} />
        </>
      )}
    </>
  );
};

export default ReferralBlueBlock;
